import { useState } from "react";
import useConsorcioStore from "../../../storeModules/useConsorcioStore";
import { createSelectedPlan } from "../utils/planUtils";
import usePaymentStore from "../../../storeModules/usePaymentStore";

export const usePlanSelection = (options) => {
  const [selectedPlanID, setSelectedPlanID] = useState(null);
  const [selectedBemID, setSelectedBemID] = useState(null);

  const setConsorcioStore = useConsorcioStore(
    (state) => state.setConsorcioStore,
  );

  const updateCheckStatus = (planoID, bemId) => {
    setSelectedPlanID(planoID);
    setSelectedBemID(bemId);

    const paymentState = usePaymentStore.getState();

    const selectedPlano = createSelectedPlan(
      planoID,
      bemId,
      options,
      setConsorcioStore,
    );

    usePaymentStore.setState({
      ...paymentState,
      firstParcel: selectedPlano.planoValorPagamento,
      firstParcelBruto: selectedPlano.planoValorPagamentoBruto,
      monthlyParcel: selectedPlano.planoValorParcela,
      couponFirstParcel: 0,
      insuranceFirstParcel: selectedPlano.valorParcelaPrimeiroPagtoComSeguro,
      insuranceMonthlyParcel: selectedPlano.valorParcelaComSeguro,
    });

    useConsorcioStore.setState({
      selectedPlano,
    });

    try {
      localStorage.setItem("mycon_selected_plano", JSON.stringify(selectedPlano));
    } catch (_) {}
  };

  const isSelectedCard = (activeSlide) => {
    if (!options[activeSlide]?.planosTipos) {
      return false;
    }

    return (
      options[activeSlide].planosTipos
        .map((plano) => plano.planoID)
        .includes(selectedPlanID) &&
      options[activeSlide].planosTipos
        .map((plano) => plano.bemId)
        .includes(selectedBemID)
    );
  };

  const selectedOptionIndex = options
    .map((option) =>
      option.planosTipos.map((plano) => ({
        planoID: plano.planoID,
        bemId: plano.bemId,
      })),
    )
    .findIndex((plano) =>
      plano.some(
        (plano) =>
          plano.planoID === selectedPlanID && plano.bemId === selectedBemID,
      ),
    );

  return {
    selectedPlanID,
    selectedBemID,
    updateCheckStatus,
    isSelectedCard,
    selectedOptionIndex,
  };
};
